/** @jsx CanvaSX */
import { CanvaSX, renderElement } from '@lib/canvasx/canvasx';
import { defaultShapeProps } from '@lib/canvasx/shapes';
import { EMOJI_FONT_FACES, lookupNativeEmoji } from '../utils/emoji';
import { Text } from '@lib/canvasx/components/Text';
import { drawRect, isSafari } from '@lib/canvasx/util';

const defaultEmojiProps = { ...defaultShapeProps };
export type EmojiProps = Partial<ShapeStruct & ScaleStruct> & {
  shortCode: string;
  scale?: number;
};

export const Emoji: CanvaSXComponent<EmojiProps, typeof defaultEmojiProps> =
  function (props) {
    const { shortCode, scale = 1, scaleX = scale, scaleY = scale } = props;
    const { ctx } = CanvaSX.context;

    const baseScale = isSafari ? 0.75 : 1;
    const { x = 0, y = 0, width, height } = props;
    drawRect(ctx, { x, y, width: width!, height: height! }, () => {
      ctx.save();
      ctx.scale(baseScale * scaleX, baseScale * scaleY);

      if (isSafari) {
        ctx.translate(0, -4);
      }

      renderElement(
        <Text face={EMOJI_FONT_FACES}>{lookupNativeEmoji(shortCode)}</Text>
      );

      ctx.restore();
    });

    return null;
  };

Emoji.defaultProps = defaultEmojiProps;
Emoji.calculateDimensions = () => {
  return {
    height: 8,
    width: 10,
  };
};
